var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 0C3.13384 0 0 3.13418 0 7C0 10.8662 3.13384 14 7 14C10.8658 14 14 10.8662 14 7C14 3.13418 10.8658 0 7 0ZM10.1359 9.23786C10.3647 9.46636 10.3647 9.83715 10.1359 10.066L10.0658 10.1364C9.83698 10.3649 9.46619 10.3649 9.23735 10.1364L7 7.89834L4.76214 10.1362C4.53364 10.3647 4.16285 10.3647 3.93402 10.1362L3.86363 10.0658C3.63513 9.83698 3.63513 9.46619 3.86363 9.23769L6.10166 7L3.8638 4.76248C3.6353 4.53364 3.6353 4.16285 3.8638 3.93402L3.93418 3.86397C4.16302 3.63513 4.53381 3.63513 4.76231 3.86397L7 6.10166L9.23752 3.86414C9.46636 3.6353 9.83715 3.6353 10.066 3.86414L10.136 3.93418C10.3649 4.16302 10.3649 4.53381 10.136 4.76265L7.89834 7L10.1359 9.23786Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappClose);
export default __webpack_public_path__ + "static/media/whatsappClose.1f9460b51006612a99beb0752c2ae779.svg";
export { ForwardRef as ReactComponent };